import { useMemo } from 'react';

import { Image } from 'components/Image';

export const useColumns = () =>
  useMemo(
    () => [
      {
        accessor: 'file',
        Cell: ({ row }: any) => {
          const { file, image, title } = row.original || {};
          const img = <Image source={image} alt={title || 'technology'} />;
          return file ? (
            <a href={file} target="_blank" rel="noreferrer">
              {img}
            </a>
          ) : (
            img
          );
        },
      },
      {
        accessor: 'title',
      },
    ],
    []
  );
